module.exports = __webpack_public_path__ + "static/img/zhiliang.cea7272b.webp";